// Exact port of p5.js's Perlin noise() + seeded random(), so v2 canopies match
// v1 for the same canopySeed. Both use p5's LCG; the perlin array is filled by
// the same generator p5 uses in noiseSeed().

const PERLIN_YWRAPB = 4;
const PERLIN_YWRAP = 1 << PERLIN_YWRAPB;
const PERLIN_ZWRAPB = 8;
const PERLIN_ZWRAP = 1 << PERLIN_ZWRAPB;
const PERLIN_SIZE = 4095;
const PERLIN_OCTAVES = 4;
const PERLIN_AMP_FALLOFF = 0.5;
const scaledCosine = (i) => 0.5 * (1.0 - Math.cos(i * Math.PI));

const LCG_M = 4294967296;
const LCG_A = 1664525;
const LCG_C = 1013904223;

export default class P5Noise {
  constructor() {
    this.perlin = null;
    this._randState = 0;
  }

  noiseSeed(seed) {
    let z = seed >>> 0;
    const rand = () => { z = (LCG_A * z + LCG_C) % LCG_M; return z / LCG_M; };
    this.perlin = new Array(PERLIN_SIZE + 1);
    for (let i = 0; i < PERLIN_SIZE + 1; i += 1) this.perlin[i] = rand();
  }

  randomSeed(seed) { this._randState = seed >>> 0; }

  random() {
    this._randState = (LCG_A * this._randState + LCG_C) % LCG_M;
    return this._randState / LCG_M;
  }

  noise(x, y = 0, z = 0) {
    if (this.perlin == null) this.noiseSeed(0);
    if (x < 0) x = -x; if (y < 0) y = -y; if (z < 0) z = -z;
    let xi = Math.floor(x); let yi = Math.floor(y); let zi = Math.floor(z);
    let xf = x - xi; let yf = y - yi; let zf = z - zi;
    let rxf; let ryf;
    let r = 0; let ampl = 0.5;
    let n1; let n2; let n3;

    for (let o = 0; o < PERLIN_OCTAVES; o += 1) {
      let of = xi + (yi << PERLIN_YWRAPB) + (zi << PERLIN_ZWRAPB);
      rxf = scaledCosine(xf); ryf = scaledCosine(yf);
      n1 = this.perlin[of & PERLIN_SIZE];
      n1 += rxf * (this.perlin[(of + 1) & PERLIN_SIZE] - n1);
      n2 = this.perlin[(of + PERLIN_YWRAP) & PERLIN_SIZE];
      n2 += rxf * (this.perlin[(of + PERLIN_YWRAP + 1) & PERLIN_SIZE] - n2);
      n1 += ryf * (n2 - n1);
      of += PERLIN_ZWRAP;
      n2 = this.perlin[of & PERLIN_SIZE];
      n2 += rxf * (this.perlin[(of + 1) & PERLIN_SIZE] - n2);
      n3 = this.perlin[(of + PERLIN_YWRAP) & PERLIN_SIZE];
      n3 += rxf * (this.perlin[(of + PERLIN_YWRAP + 1) & PERLIN_SIZE] - n3);
      n2 += ryf * (n3 - n2);
      n1 += scaledCosine(zf) * (n2 - n1);
      r += n1 * ampl;
      ampl *= PERLIN_AMP_FALLOFF;
      xi <<= 1; xf *= 2; yi <<= 1; yf *= 2; zi <<= 1; zf *= 2;
      if (xf >= 1) { xi += 1; xf -= 1; }
      if (yf >= 1) { yi += 1; yf -= 1; }
      if (zf >= 1) { zi += 1; zf -= 1; }
    }
    return r;
  }
}
